<template>
  <v-card outlined class="dimension-card pa-3">
    <div class="caption text-uppercase text--secondary mb-2">
      <v-icon>mdi-arrow-all</v-icon>
      Dimensions
    </div>
    <v-row dense>
      <v-col cols="12" sm="6">
        <v-select
          v-model="local.type"
          :items="typeOptions"
          label="Type de surface"
          dense
          outlined
          hide-details="auto"
        />
      </v-col>
      <v-col cols="8" sm="4">
        <v-text-field
          v-model="local.value"
          label="Valeur"
          type="number"
          dense
          outlined
          hide-details="auto"
        />
      </v-col>
      <v-col cols="4" sm="2">
        <v-text-field
          v-model="local.unit"
          label="Unité"
          dense
          outlined
          hide-details="auto"
        />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: 'DimensionCard',
  props: {
    value: { type: Object, required: true },
  },
  data() {
    return {
      local: {
        type: this.value.type || null,
        value: this.value.value || '',
        unit: this.value.unit || 'm²',
      },
      typeOptions: ['au sol', 'murs à isoler'],
    }
  },
  watch: {
    local: {
      deep: true,
      handler(v) {
        this.$emit('input', {
          ...this.value,
          type: v.type,
          options: v.type, // preserve the backend field (same value as type)
          value: v.value,
          unit: v.unit,
        })
      },
    },
  },
}
</script>

<style scoped>
.dimension-card {
  background: var(--app-card-bg, #fff);
}
</style>
